import FindLocationResultState from '../data/schema/FindLocationResultState';
import getFindResultsOffset from './getFindResultsOffset';

export default function getLocationDropdownResultData(
    disableUseThisLocation: boolean,
    findLocationResultState: FindLocationResultState
): { findResultOffset: number; findResultsCount: number } {
    let findResultOffset: number = getFindResultsOffset(
        findLocationResultState,
        disableUseThisLocation
    );

    let findResultsCount: number = findLocationResultState.findResultSet
        ? findLocationResultState.findResultSet.length
        : 0;

    return {
        findResultOffset: findResultOffset,
        findResultsCount: findResultsCount,
    };
}
